import { API_NEW } from 'src/API';
import { CustomerListItemType } from './Types';

/**  */
export default class CustomerAPI extends API_NEW {
	/** Получение списка заявителей */
	static getCustomers = (term = '') => {
		return this.onRequest<CustomerListItemType[]>({
			url:
				window.host +
				'/WebInterfaceModule/Search/GetCustomers?term=' +
				term,
			withCredentials: true,
		});
	};

	/** Получение заявителя по его ИД */
	static getCustomerById = (id: string) => {
		return this.onRequest<CustomerListItemType | null>({
			url:
				window.host +
				'/WebInterfaceModule/Search/GetCustomerTextById?ElementId=' +
				id,
			withCredentials: true,
		});
	};
}
